/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import colorsDark from '../../assets/colors/dark';
import { PHONE_STATES } from '../../constants/system.keys';
import { calDuration } from '../../untils/date';
import { RingPhone } from './PhoneRing';
import './index.scss';

export const Calling = ({ onCancelCall, phone, phoneState }) => {
  const { t } = useTranslation();
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [intervalTime, setIntervalTime] = useState();

  useEffect(() => {
    if (phoneState !== PHONE_STATES.IN_CALL) {
      setStartTime(null);
      setEndTime(null);
      if (intervalTime) {
        clearInterval(intervalTime);
      }
    } else {
      setStartTime(moment().unix());
      setEndTime(moment().unix());
      const it = setInterval(() => {
        setEndTime(moment().unix());
      }, 1000);

      setIntervalTime(it);
    }

    return () => {
      if (intervalTime) {
        clearInterval(intervalTime);
      }
    };
  }, [phoneState]);

  return (
    <div className="dial-calling-wrap">
      <div className="info">
        {phoneState === PHONE_STATES.CALLING_OUT && (
          <span className="title">{t('Calling to')}</span>
        )}
        {phoneState === PHONE_STATES.IN_CALL && (
          <span className="title">{t('In call with')}</span>
        )}
        <span className="phone">{phone}</span>
        {phoneState === PHONE_STATES.IN_CALL && (
          <span>{calDuration(startTime, endTime)}</span>
        )}
        {phoneState === PHONE_STATES.CALLING_OUT && <RingPhone />}
      </div>
      <Button
        className="delete"
        style={{
          color: colorsDark.$errors,
          borderColor: colorsDark.$errors,
          width: '100%',
        }}
        onClick={() => {
          if (typeof onCancelCall === 'function') {
            onCancelCall();
          }
        }}
      >
        {t('Terminate')}
      </Button>
    </div>
  );
};

export default Calling;
